var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8402 2.66697C2.45781 2.65734 2.08666 2.79691 1.80538 3.05615C1.52411 3.31539 1.35478 3.67394 1.33325 4.05586V11.3406C1.33325 11.7826 1.50885 12.2065 1.82141 12.5191C2.13397 12.8316 2.55788 13.0072 2.99991 13.0072H12.9999C13.219 13.0081 13.4362 12.9657 13.6388 12.8822C13.8414 12.7988 14.0255 12.6761 14.1805 12.5211C14.3354 12.3662 14.4581 12.1821 14.5416 11.9795C14.625 11.7768 14.6675 11.5597 14.6666 11.3406V4.06279C14.6468 3.68148 14.4789 3.32298 14.1988 3.06357C13.9186 2.80416 13.5483 2.66434 13.1666 2.6739L2.8402 2.66697ZM4.29852 5.3753C4.11434 5.25282 3.88907 5.20852 3.67223 5.25214C3.45539 5.29577 3.26476 5.42375 3.14228 5.60793C3.01981 5.79211 2.97551 6.0174 3.01913 6.23424C3.06276 6.45108 3.19074 6.6417 3.37492 6.76418L7.54158 9.54195C7.67803 9.63391 7.83884 9.68303 8.00339 9.68303C8.16793 9.68303 8.32872 9.63391 8.46518 9.54195L12.6318 6.76418C12.816 6.6417 12.944 6.45108 12.9876 6.23424C13.0313 6.0174 12.987 5.79211 12.8645 5.60793C12.742 5.42375 12.5514 5.29577 12.3345 5.25214C12.1177 5.20852 11.8924 5.25282 11.7082 5.3753L7.99991 7.84751L4.29852 5.3753Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon5);
export default __webpack_public_path__ + "static/media/email-icon-5.3b7fc05ec2017bbf155d24a115837fc9.svg";
export { ForwardRef as ReactComponent };